export default __webpack_public_path__ + "static/media/myApp_guid.1857ef97.png";